"use client";

import { useEffect } from "react";
import {
	ConsentCategory,
	useScriptLoader,
	useCookiePreferences,
} from "cookiebanner-finally";

export function ScriptLoaderConsent() {
	const { preferences } = useCookiePreferences();
	const { register, load } = useScriptLoader();

	useEffect(() => {
		// Register HubSpot script only
		register({
			id: "hubspot",
			category: ConsentCategory.Marketing,
			src: "//js-eu1.hs-scripts.com/146426345.js",
			attributes: {
				async: "true",
				defer: "true",
			},
		});
	}, [register]);

	useEffect(() => {
		// Load HubSpot script based on consent preferences
		if (preferences.marketing) {
			load("hubspot");
		}
	}, [preferences, load]);

	return null;
}

